import { useQuery } from "@apollo/client";
import { useMemo } from "react";
import {
  CompanyFilter,
  CompanyMatchFilter,
} from "../../../../../legacy/types/companyFilter";
import { GMA_GEO_SPEND_QUERY } from "../../../../../legacy/queries/MI";
import { COMPANY_SEARCH_CLIENT } from "../../../../../utils/consts";
import { SpendBreakdownResult } from "../../../../../legacy/types/companySearch/MI";
import { useWorkspaceStore } from "../../../../../store/workspace/WorkspaceStore";

interface GmaGeoSpendPayload {
  globalMarketAnalysisGeopoliticalRegionBreakdown: RegionSpendBreakdown[];
}

interface RegionSpendBreakdown {
  companyCount: number;
  totalSpend: number;
  regionId?: string;
  regionName?: string;
}

interface GmaGeoSpendVariables {
  companyFilters?: CompanyFilter;
  customSpendCategory?: {
    name: string;
    categories: Array<{ id: string; weight: number }>;
  };
  localizeInstalls?: boolean;
  companyMatchFile?: CompanyMatchFilter;
}

interface Props {
  companyFilters: CompanyFilter;
  customSpendCategory?: {
    name: string;
    categories: Array<{ id: string; weight: number }>;
  };
  localizeInstalls?: boolean;
}

export function useGetSpendByRegionData(props: Props) {
  const workspaceWhitespace = useWorkspaceStore(
    (state) => state.draft?.configuration?.whitespace
  );

  const { data, loading } = useQuery<GmaGeoSpendPayload, GmaGeoSpendVariables>(
    GMA_GEO_SPEND_QUERY,
    {
      variables: {
        companyFilters: props.companyFilters,
        customSpendCategory: props.customSpendCategory,
        localizeInstalls: props.localizeInstalls,
        companyMatchFile:
          props.companyFilters?.opportunityType &&
          workspaceWhitespace?.fileId &&
          workspaceWhitespace?.lastMatched
            ? workspaceWhitespace
            : undefined,
      },
      context: {
        clientName: COMPANY_SEARCH_CLIENT,
      },
    }
  );

  const spendBreakDownResult = useMemo<SpendBreakdownResult[]>(() => {
    return (
      data?.globalMarketAnalysisGeopoliticalRegionBreakdown.map(
        ({ companyCount, totalSpend, regionName }) => ({
          id: regionName,
          spend: totalSpend,
          companies: companyCount,
          dimension: regionName,
        })
      ) ?? []
    );
  }, [data?.globalMarketAnalysisGeopoliticalRegionBreakdown]);

  return {
    spendByRegionChartData: spendBreakDownResult,
    loading,
  };
}
